module.exports = __webpack_public_path__ + "img/panelView_blueBg_2_1.03981629.png";